import React from "react";
import APP_ROUTES from "./routes";

import Dashboard from "src/pages/Dashboard";
import ProjectInstance from "src/pages/ProjectInstance";
import TestPackagePage from "src/pages/TestPackage";
import Sequence from "src/pages/Sequence";
import Error404 from "src/pages/NotFound";
import Token from "src/pages/Token";
import AccessDenied from "src/pages/AccessDenied";
import MainLayout from "src/layouts/MainLayout";
import Notifier from "src/components/Common/Notifier";
import Instance from "src/pages/ProjectInstance/new";
import InstanceDetail from "src/pages/ProjectInstance/detail";
import TestPackageDetail from "src/pages/TestPackage/detail";
import NewTestPackagePage from "src/pages/TestPackage/new";
import SequenceDetail from "src/pages/Sequence/detail";

const Routes = [
  {
    path: APP_ROUTES.HOME,
    element: (
      <>
        <Notifier />
        <MainLayout />
      </>
    ),
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: APP_ROUTES.PROJECT_INSTANCE,
        element: <ProjectInstance />,
      },
      {
        path: APP_ROUTES.INSTANCE_NEW,
        element: <Instance />,
      },
      {
        path: APP_ROUTES.INSTANCE_DETAIL,
        element: <InstanceDetail />,
      },
      {
        path: APP_ROUTES.TEST_PACKAGE,
        element: <TestPackagePage />,
      },
      {
        path: APP_ROUTES.TEST_PACKAGE_NEW,
        element: <NewTestPackagePage />,
      },
      {
        path: APP_ROUTES.TEST_PACKAGE_DETAIL,
        element: <TestPackageDetail />,
      },
      {
        path: APP_ROUTES.SEQUENCES,
        element: <Sequence />,
      },
      {
        path: APP_ROUTES.SEQUENCE_DETAIL,
        element: <SequenceDetail />,
      },
    ],
  },
  {
    path: APP_ROUTES.TOKEN_PAGE,
    element: <Token />,
  },
  {
    path: APP_ROUTES.ACCESS_DENIED,
    element: <AccessDenied />,
  },
  {
    path: "*",
    element: <Error404 />,
  },
];

export default Routes;
